import * as fromDevices from '../actions/device.action';
import { IDeviceState } from '@app/shared/model/interfaces/store/device-state';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

export const BREAKPOINTS = {
  xlarge: 1440,
  large: 1024,
  medium: 768,
  small: 375
};

const defaultDeviceState: IDeviceState = {
  width: 1000,
  height: 400,
  type: 'desktop',
  orientation: 'land',
  isXsOnly: false,
  isSmUp: false,
  isSmOnly: false,
  isMdUp: false,
  isMdOnly: false,
  isLgUp: false,
  isLgOnly: false,
  isXlUp: false,
  isTouch: false,
  isIos: false,
  isAndroid: false
};

// Warning: looks like we broke navigator with ng-9 migation
const userAgent: string = isPlatformBrowser(PLATFORM_ID) && navigator.userAgent ? navigator.userAgent : '';

export function reducer(state: IDeviceState = defaultDeviceState, action: fromDevices.DeviceActions) {
  switch (action.type) {
    case fromDevices.SET_VIEWPORT_WIDTH:
      const deviceWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      return { ...state, width: deviceWidth };

    case fromDevices.SET_VIEWPORT_HEIGHT:
      const deviceHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      return { ...state, height: deviceHeight };

    case fromDevices.SET_IS_XS_ONLY:
      return { ...state, isXsOnly: action.payload < BREAKPOINTS.small };

    case fromDevices.SET_IS_SM_UP:
      return { ...state, isSmUp: action.payload >= BREAKPOINTS.small };

    case fromDevices.SET_IS_SM_ONLY:
      return { ...state, isSmOnly: action.payload >= BREAKPOINTS.small && action.payload < BREAKPOINTS.medium };

    case fromDevices.SET_IS_MD_UP:
      return { ...state, isMdUp: action.payload >= BREAKPOINTS.medium };

    case fromDevices.SET_IS_MD_ONLY:
      return { ...state, isMdOnly: action.payload >= BREAKPOINTS.medium && action.payload < BREAKPOINTS.large };

    case fromDevices.SET_IS_LG_UP:
      return { ...state, isLgUp: action.payload >= BREAKPOINTS.large };

    case fromDevices.SET_IS_LG_ONLY:
      return { ...state, isLgOnly: action.payload >= BREAKPOINTS.large && action.payload < BREAKPOINTS.xlarge };

    case fromDevices.SET_IS_XL_UP:
      return { ...state, isXlUp: action.payload >= BREAKPOINTS.xlarge };

    case fromDevices.SET_IS_TOUCH:
      return { ...state, isTouch: 'ontouchstart' in window };

    case fromDevices.SET_IS_IOS:
      let isIos = false;
      if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
        isIos = true;
      }
      return { ...state, isIos: isIos };
    case fromDevices.SET_IS_ANDROID:
      let isAndroid = false;
      if (userAgent.match(/Android/i)) {
        isAndroid = true;
      }
      return { ...state, isAndroid: isAndroid };
    default:
      return state;
  }
}
